import { constructionSafety, logisticsAsset, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'Trong bài viết này, ORBRO sẽ cùng bạn làm rõ IPS (Định vị trong nhà) là gì, phân tích các công nghệ phổ biến, lợi ích và vai trò của IPS trong chuyển đổi số.',
  keywords: 'ips, định vị trong nhà, ips là gì, indoor positioning system, định vị vị trí',
  ogSite: 'IPS (Định vị trong nhà) là gì? Vai trò của IPS trong công nghệ?',
  title: 'IPS (Định vị trong nhà) là gì? Vai trò của IPS trong công nghệ?',
  ogUrl: 'https://orbro.io/vi/blog/ips-dinh-vi-trong-nha-la-gi',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_Ee2QjIbPoqtMws-QeLngrnMGwZ_iWuw6RlX3oY0eN3riOU7I2EhAVHQ-Zm9f6rp8F7Ps8b0U9DQBWVqED5UvF5_968GQXtpMNNZyqBl56EN6_N5-y0m-hKCU6bGtqi5k4YFQyGbDgVwAAqxRcDRJUeOH8-PyeX-At9AAP5_hOcgbl21ysBQXdJ4tX8sAW-tBwLD40xLU9andLwjMbUPDpopf0VZG1j5QMUlC5z82MgXrhxGcuqmEILnu4QujlcvlYXbd5NIcDRPFsNwt3Zrfm6d3bfTyYwrJEZrLeHrtzk1jZ2Tf8uv3vI_eZRteRcLUAtynMnscR2f2yeRZv81eJS1lRNBKHX735-4xwFC-sm1JLyNv_9hrqiEJ8UykU4RqdjCUnmtWMIkXGxfWm7VqTSWYk6AMmLn_uQHQHykw9wU0376w2cFllnNPFisG442MeguhycB9t1dl8LIUn_p1huSgMFtlV0D_mZ_6D16ozjTwjymVm8gdn6_RmeyuaJaCmXD-dVhWNM6wgjDnoTAZvMXL1jgy8lpBQnOwNe924rpPg1ezIbXkvzzTdAVMrfUSOSLaX4P9kGfjwP9nkUdfABRs6AijBCfxnGzoGNZ45vXuGFdZATaCpsQhPLLYqn7szSpKF-UvcA2gdFYArytVPBoHhH2zA4gmIvuXTb7XqmW7Xh6iksq1-etgMymDEyP_0Meq2ciQv6v1MF53Wx9iYHaf5-uZAkr5VQtszbeCuKxcifqtGBuh3ck99flcKndxdWUZSOJA2TxLRAoII6fkySA-aUJqFuXKUXonm5Zj4M3wxAdI4RiCJynIdjYUvi-WzcZAbQ44V31xsdW_6n2zD6SPsN0dtxie7IPCV1IO4Cg4CZncsKF31DMh2x0hoTHQ882MupTgOOcjuOwKlqIyuj65xucBPQubjDwAB_Ej9j07TtLBFQDPh4kTYcpzO2wUVZX4rozeKkE38nnFG-sbLw7G9d3-x72laYgn7mCR7XfnHoPtq6wIDc273aSuiXyXz4WJXZ45D46b1l5AumfxhTF_sFQsZE8eNiQ9lwqDhdnerrNpjtAutDrO7RFT3pFAbgJVFoAlLthf84761-jKFkyYu_TcZCIps0oJKeshjzsMWeYECxNJpdXqoQvaDddm6STeB_4jzqahHisT98KtEfIsAuLhl1Wdv0MepnVa5AMn04rJt2TPly_6TnEcflRacVBxJtIjBRYLWzpUROkxFf1mXxXmDtbe0P9wFmjbM3QDDC-_tiNQYli4RoFYTik6mrc6Yhc5QBdS75QTbmxgRptJBkSrRfsekRYNXLGIDijPQ96Ql-wyg1VbZ5GrFXgZzsypWqnEwLfigSrDtOBjptTUWSOFVQlvPNs_paVvxoWncck163gzvi0Oeb94y12fvfLqhBjL7q0rztwFD4Urv5rPsLq_VHA4oc0bNR76szmQTjj8ZWA3HJRMtfC6bt8ZKVcSAfJmKbnYVZSdi8Qnf2sp2Hc6pzibD8cUOPYwb5DQdWyg3BR9j0Jvl1isUV5QtRjhXojQwccE4lDiEQHUzTM53G6AOFReY65Rsrigw0s3Hf1QHuNnRJVv9jmEVACrvt1goN2NulENTfvx5yro8Ea2bL6P5C4VkYjw=w1502-h1410?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#ips',
  tag2: '#indoorpositioningsystem',
  tag3: '#dinhvitrongnha',
  tag4: '#dinhvivitri',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong kỷ nguyên Công nghiệp 4.0, IPS (Indoor Positioning System) – định vị trong nhà – đã trở thành giải pháp then chốt giúp doanh nghiệp và tổ chức kiểm soát vị trí người, thiết bị và tài sản bên trong không gian kín. Khác với GPS chỉ hoạt động ngoài trời, IPS sử dụng các công nghệ như Wi‑Fi, BLE, UWB, RFID để định vị chính xác trong nhà xưởng, trung tâm thương mại, sân bay và nhiều môi trường phức tạp khác.\n\nTrong bài viết này, ORBRO sẽ cùng bạn làm rõ IPS (Định vị trong nhà) là gì, phân tích các công nghệ phổ biến, lợi ích và vai trò của IPS trong chuyển đổi số.',
      dot: ''
    },
    {
      head: '1. IPS (Định vị trong nhà) là gì?',
      subHead: '',
      desc: 'IPS (Indoor Positioning System) là hệ thống xác định vị trí trong môi trường trong nhà với độ chính xác cao (thường từ vài chục cm đến vài mét). Hệ thống định vị trong nhà IPS bao gồm:\n\n• Tags/Beacons: Các thiết bị phát tín hiệu được gắn trên đối tượng cần theo dõi.\n\n• Anchors/Receivers: Điểm thu/phát tín hiệu lắp đặt cố định khắp khu vực.\n\n• Phần mềm xử lý: Tính toán tọa độ dựa trên cường độ tín hiệu, thời gian truyền và thuật toán multilateration.',
      dot: ''
    },
    {
      head: '2. Các công nghệ IPS (Định vị trong nhà) phổ biến',
      subHead: 'BLE (Bluetooth Low Energy)',
      desc: '• Ưu điểm: Chi phí thấp, tiêu thụ năng lượng ít, dễ triển khai trên hạ tầng Bluetooth hiện có.\n• Nhược điểm: Độ chính xác ~1–3 m.',
      dot: ''
    },
    {
      head: '',
      subHead: 'UWB (Ultra-Wideband)',
      desc: '• Ưu điểm: Độ chính xác cao (±10–30 cm), kháng nhiễu tốt.\n• Nhược điểm: Chi phí đầu tư cao, yêu cầu phần cứng chuyên dụng.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Wi‑Fi RTT (Round-Trip Time)',
      desc: '• Ưu điểm: Tận dụng hạ tầng Wi‑Fi sẵn có, độ chính xác ~1–2 m.\n• Nhược điểm: Phụ thuộc chất lượng AP và cấu hình.',
      dot: ''
    },
    {
      head: '',
      subHead: 'RFID',
      desc: '• Ưu điểm: Xác lập vùng đọc cố định, chi phí tiết kiệm cho thẻ passive.\n• Nhược điểm: Phạm vi ngắn, chỉ xác định khi qua cổng đọc.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Camera Vision',
      desc: '• Ưu điểm: Kết hợp nhận diện hình ảnh, không cần gắn tag.\n• Nhược điểm: Chi phí cao, phức tạp về xử lý hình ảnh.',
      dot: ''
    },
    {
      head: '3. Vai trò của IPS (Định vị trong nhà) trong công nghệ',
      subHead: '',
      desc: '• Quản lý tài sản và thiết bị\nTheo dõi thời gian thực: Xác định vị trí xe nâng, pallet, thiết bị y tế trong bệnh viện.\nTối ưu quy trình: Giảm thời gian tìm đồ, tăng năng suất vận hành.\n\n• Cải thiện an ninh và an toàn\nGiám sát con người: Theo dõi nhân viên vào khu vực nguy hiểm, cảnh báo khi vùng cấm bị xâm phạm.\nỨng cứu khẩn cấp: Xác định nhanh vị trí người gặp nạn trong nhà máy hoặc tòa nhà cao tầng.\n\n• Tối ưu trải nghiệm khách hàng\nHướng dẫn trong trung tâm thương mại: Ứng dụng di động chỉ đường đến cửa hàng, toilet, quầy dịch vụ.\nDu lịch thông minh: Chỉ dẫn lối đi tại sân bay, bảo tàng.\n\n• Phân tích dữ liệu và cải thiện quy trình\nHeatmap hành vi: Xác định điểm tập trung đông người, tối ưu bố trí gian hàng hoặc chỗ ngồi.\nDự báo lưu lượng: AI dự đoán khu vực đông đúc, điều phối nhân sự và phương tiện.',
      dot: ''
    },
    {
      head: '4. Lợi ích khi triển khai IPS (Định vị trong nhà)',
      subHead: '',
      desc: '• Độ chính xác cao: Theo dõi vị trí với sai số chỉ vài chục cm.\n\n• Tiết kiệm chi phí: Giảm lãng phí thời gian và nhân lực tìm kiếm.\n\n• Nâng cao an toàn: Cảnh báo kịp thời tình huống nguy hiểm.\n\n• Tối ưu trải nghiệm: Hành trình liền mạch cho khách và nhân viên.\n\n• Dữ liệu sáng suốt: Báo cáo và phân tích giúp ra quyết định nhanh chóng.',
      dot: ''
    },
    {
      head: '5. Kết luận',
      subHead: '',
      desc: 'IPS đã trở thành hạ tầng định vị thiết yếu trong các môi trường trong nhà phức tạp. Bằng cách ứng dụng các công nghệ như BLE, UWB, Wi‑Fi RTT và RFID, doanh nghiệp có thể quản lý tài sản, nâng cao an toàn, tối ưu trải nghiệm và ra quyết định dựa trên dữ liệu. Đầu tư vào IPS chính là bước đi chiến lược để đón đầu xu hướng công nghệ và phát triển bền vững. Hãy cùng ORBRO ứng dụng hệ thống IPS (Định vị trong nhà) cho căn nhà, doanh nghiệp của bạn để theo kịp thời đại công nghệ nhé!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
